import RecommendedUtmLinks from "@/pages/admin/RecommendedUtmLinks";
import { Link2 } from "lucide-react";

/* Campaign Links tab — admin-only copy-ready UTM URLs.
 * Thin wrapper around the existing RecommendedUtmLinks panel so all link
 * generation logic stays unchanged (Cash Discount → /cash-discount-savings,
 * Free POS → /free-pos-offer, Savings Analysis → /savings-analysis). */
export default function CampaignLinksTab() {
  return (
    <div data-testid="campaign-links-tab" className="space-y-5">
      <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-7">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-xl bg-[var(--swipe-soft-blue)] text-[var(--swipe-accent)] flex items-center justify-center shrink-0">
            <Link2 className="w-6 h-6" strokeWidth={2.25} />
          </div>
          <div>
            <h2 className="font-display-tight text-[1.4rem] sm:text-[1.6rem] font-extrabold text-[var(--swipe-navy)] leading-[1.15]">
              Campaign Links
            </h2>
            <p className="mt-2 text-[14px] text-slate-600 leading-[1.65] max-w-2xl">
              Copy-ready, UTM-tagged URLs for every source × promotion combination.
              Cash Discount campaigns point to <code className="text-[12px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-700">/cash-discount-savings</code>,
              Free POS to <code className="text-[12px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-700">/free-pos-offer</code>, and
              Savings Analysis to <code className="text-[12px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-700">/savings-analysis</code>.
              Never use the public pages for paid ads.
            </p>
          </div>
        </div>
      </div>

      <RecommendedUtmLinks />
    </div>
  );
}
